angular.module('dnecom')
    .service('StoreUtils', ['$http', 'Upload', 'notifications', function ($http, Upload, notifications) {
        this.upload = function (store, file, callback, triggerNotification) {
            if (file) {
                var storeId = (store === null) ? 0 : store.id;

                Upload.imageDimensions(file)
                    .then(function (dimensions) {
                        Upload.upload({
                            url: Routing.generate('upload_file', {store: storeId}),
                            data: {
                                file: file,
                                dimensions: dimensions
                            }
                        })
                            .then(function (response) {
                                if (response.data.success) {
                                    if (typeof triggerNotification === 'undefined' || triggerNotification) {
                                        notifications.success('File uploaded successfully!');
                                    }

                                    callback(response.data.media);
                                } else {
                                    alert(response.data.message);
                                }
                            }, function () {
                                alert('There was a problem with file uploading.');
                            });
                    });
            }
        };

        this.uploadUrl = function (store, url, callback, errorCallback) {
            if (url && url.length > 0) {
                $http.post(Routing.generate('upload_file', {store: store.id}), {
                    image: url
                })
                .then(function (response) {
                    if (response.data.success) {
                        notifications.success('File uploaded successfully!');

                        callback(response.data.media);
                    } else {
                        alert(response.data.message);
                        if (typeof errorCallback === 'function') {
                            errorCallback();
                        }
                    }
                }, function () {
                    alert('There was a problem with file uploading.');
                });
            }
        };

        this.setFieldValue = function (store, parentField, field, value) {
            if (!store.properties) {
                store.properties = {};
            }

            if (!store.properties[parentField]) {
                store.properties[parentField] = {};
            }

            store.properties[parentField][field] = value;
        };

        this.getFieldValue = function (store, parentField, field) {
            if (!store.properties) {
                return undefined;
            }

            if (!store.properties[parentField]) {
                return undefined;
            }

            return store.properties[parentField][field];
        };

        this.setMobileFieldValue = function (store, parentField, field, value) {
            if (!store.mobileProperties) {
                store.mobileProperties = {};
            }

            if (!store.mobileProperties[parentField]) {
                store.mobileProperties[parentField] = {};
            }

            store.mobileProperties[parentField][field] = value;
        };

        this.getMobileFieldValue = function (store, parentField, field) {
            if (!store.mobileProperties) {
                return undefined;
            }

            if (!store.mobileProperties[parentField]) {
                return undefined;
            }

            return store.mobileProperties[parentField][field];
        };

        this.getUrl = function (store, path) {
            if (_.isUndefined(path)) {
                path = Routing.generate('stores_fe_index');
            }

            if (store.domain) {
                return 'http://' + store.domain + path;
            }

            if (store.subdomain) {
                return '//' + store.subdomain + '.' + window.ies.domain + path;
            }

            return '';
        };

        this.generateRoute = function(store, routeName, routeParams, withProtocol) {
            if (_.isUndefined(withProtocol)) {
                withProtocol = false;
            }

            var path = Routing.generate(routeName, routeParams);

            if (store && store.domain) {
                return 'http://' + store.domain + path;
            }

            if (store && store.subdomain) {
                return (withProtocol ? window.location.protocol : '') + '//' + store.subdomain + '.' + window.ies.domain + path;
            }

            return '#';
        };

        this.activateMobileStore = function (store, callback, errorCallback) {
            $http
                .post(Routing.generate('stores_activate_mobile', { id: store.id }))
                .then(function (response) {
                    if (response.data.success) {
                        if (callback) {
                            callback(response.data);
                        }
                    } else {
                        if (errorCallback) {
                            errorCallback(response.data);
                        }
                    }
                }, function (response) {
                    if (errorCallback) {
                        errorCallback(response.data);
                    }
                });
        };

        return this;
    }]);
